
import {
    Box, TextField, FormControl, InputAdornment, InputLabel, Input, IconButton, Button,
    Typography, Select, MenuItem, FormHelperText, Alert, Backdrop, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions
} from '@mui/material';
import { AccountCircleOutlined, Visibility, VisibilityOff, LockOutlined, Group } from '@mui/icons-material';
import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { set } from 'lodash';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';



export const Modal = ({ children, open, handleClose, head, buttons, desc, styleA }) => {

    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

    return (
        <Dialog open={open} onClose={handleClose} fullWidth={true} maxWidth={styleA || 'sm'}>
            <DialogTitle>{head}</DialogTitle>
            <DialogContent>
                {
                    desc&&
                    <DialogContentText>
                        {desc}
                     </DialogContentText>
                }
                
                {children}
            </DialogContent>
            <DialogActions>
                {
                    Array.isArray(buttons) &&
                    buttons.map((btn, i) => {
                        return (
                            <Button key={i} onClick={btn.onClick}>{btn.name}</Button>
                        )
                    })
                }
            </DialogActions>
        </Dialog>
    )
}